import * as React from "react";
import { style, media } from "typestyle";
import { colors, queries } from "styles/styles";

const className = style(
  {
    fontSize: "26px",
    fontWeight: 900,
    color: colors.hooplaTextColor,
    marginBottom: "1rem",
  },
  media(queries.medium, {
    textAlign: "left",
  }),
);

const PageHeader: React.FC<{ children?: React.ReactNode }> = ({ children }) => (
  <div className={className}>{children}</div>
);

export default PageHeader;
